import React from 'react';
import { WarningBanner } from '@app/react-common/components/banners/WarningBanner';

export const ThemeWinnerSuccessContent: React.FC = () => {
  return (
    <div className="theme-winner-success-content">
      <WarningBanner
        title="Winner recorded — publish your theme to make it live"
        content={`Your winning theme has been saved, but no changes were made to your store. To go live, publish the winning theme in Shopify and update your checkout groups in PDQ`}
        hideCloseButton={true}
        variant="attention"
      />

      <div className="theme-winner-success-content__steps">
        <div className="theme-winner-success-content__step">
          <div className="theme-winner-success-content__step-number">1</div>
          <div className="theme-winner-success-content__step-content">
            <h5 className="theme-winner-success-content__step-title">Publish your winning theme in Shopify</h5>
            <p className="theme-winner-success-content__step-description">
              Go to Online Store → Themes and publish the winning theme.
            </p>
          </div>
        </div>

        <div className="theme-winner-success-content__step">
          <div className="theme-winner-success-content__step-number">2</div>
          <div className="theme-winner-success-content__step-content">
            <h5 className="theme-winner-success-content__step-title">Update your checkout groups in PDQ</h5>
            <p className="theme-winner-success-content__step-description">
              Set the checkout group matching your winning theme to Live. If you had a checkout group for the losing
              theme, set it to Off.
            </p>
          </div>
        </div>

        <div className="theme-winner-success-content__step">
          <div className="theme-winner-success-content__step-number">3</div>
          <div className="theme-winner-success-content__step-content">
            <h5 className="theme-winner-success-content__step-title">Verify everything is working</h5>
            <p className="theme-winner-success-content__step-description">
              Visit your storefront and place a test order to confirm your theme and checkout are displaying correctly.
            </p>
          </div>
        </div>
      </div>

      <p className="theme-winner-success-content__footer">
        Your test results and ROI data will stay available in PDQ for future reference.
      </p>
    </div>
  );
};
